import React, {useState} from "react";
import {Page} from "../../components/page/page";
import {ChooseList} from "../../components/choose-list/choose-list";
import {useDispatch} from "react-redux";

const options = [
  {
    title: "Find my perfect partner",
    icon: "❤️",
  },
  {
    title: "Check compatibility",
    icon: "🧩",
  },
  {
    title: "Improve my sexual life",
    icon: "🍓",
  },
  {
    title: "Find my true love",
    icon: "😻",
  },
  {
    title: "Get married",
    icon: "💍",
  },
  {
    title: "Make my crush fall in love with me",
    icon: "🔥",
  },
  {
    title: "Other",
    icon: "🤷",
  },
];

const RelationshipGoalsPage = () => {
  const dispatch = useDispatch();
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
  };

  return (
    <Page
      title="What are your relationship goals?"
      nextPageLink="../personal-reading"
      currentStep="4"
      canGoToNextPage={selectedOptions.length >= 1}
      onContinue={() => {
        // dispatch((selectedOptions)); // TODO
      }}
    >
      <ChooseList options={options} maxSelected={7} onChange={handleChange} />
    </Page>
  );
};

export { RelationshipGoalsPage };
